import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function AddCircle({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 18.8337C14.6025 18.8337 18.3334 15.1027 18.3334 10.5003C18.3334 5.89795 14.6025 2.16699 10.0001 2.16699C5.39771 2.16699 1.66675 5.89795 1.66675 10.5003C1.66675 15.1027 5.39771 18.8337 10.0001 18.8337ZM10.6251 8.00033C10.6251 7.65515 10.3453 7.37533 10.0001 7.37533C9.6549 7.37533 9.37508 7.65515 9.37508 8.00033L9.37508 9.87535H7.50008C7.1549 9.87535 6.87508 10.1552 6.87508 10.5003C6.87508 10.8455 7.1549 11.1253 7.50008 11.1253H9.37508V13.0003C9.37508 13.3455 9.6549 13.6253 10.0001 13.6253C10.3453 13.6253 10.6251 13.3455 10.6251 13.0003L10.6251 11.1253H12.5001C12.8453 11.1253 13.1251 10.8455 13.1251 10.5003C13.1251 10.1552 12.8453 9.87535 12.5001 9.87535H10.6251V8.00033Z"
        fill="currentColor"
      />
    </svg>
  )
}
